import styled from "styled-components";

//components
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { default as Svg12 } from "@swiggy-private/dls-web-icons/dist/web/generic/chevronDown/12";
import { Image } from "@swiggy-private/dls-web-core/dist/components/Image";

const MAX_HEIGHT = "1000px";

export const StyledWrapper = styled.div`
    overflow: hidden;
`;

export const StyledText = styled(Text)`
    text-transform: uppercase;
    margin: ${({ theme }) => `${theme.spacing.xSmall} ${theme.spacing.medium} 0`};
    letter-spacing: 1.5px;
`;

export const TitleText = styled(Text)<{ isCollapsible?: boolean }>(
    ({ isCollapsible = false }) =>
        !isCollapsible && {
            textTransform: "uppercase",
            letterSpacing: "1.5px",
        },
);

export const TabWrapper = styled.div<{ isPopCart?: boolean; isCollapsed?: boolean }>(
    ({ theme, isPopCart, isCollapsed }) => ({
        background: theme.colors[theme.colorMode].background_Primary,
        borderRadius: theme.cornerRadius.medium,
        padding: `${theme.spacing.xSmall} ${theme.spacing.empty}`,
        ...(isPopCart && {
            paddingBottom: 0,
        }),
        ...(isCollapsed && {
            paddingBottom: theme.spacing.medium,
        }),
    }),
);

export const CollapsibleHeader = styled.div<{
    isExpanded?: boolean;
    currentRotation?: number;
}>(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    cursor: "pointer",
    padding: `${theme.spacing.xSmall}  ${theme.spacing.medium} ${theme.spacing.empty} ${theme.spacing.medium}`,
    transition: "all 0.4s ease",
}));

export const CollapsibleContent = styled.div<{
    isExpanded?: boolean;
    currentRotation?: number;
}>(
    {
        maxHeight: 0,
        overflow: "hidden",
        transition: `max-height 0.6s cubic-bezier(0.4, 0.0, 0.2, 1), opacity 0.6s ease-in-out`,
        opacity: 0,
    },
    ({ isExpanded }) =>
        isExpanded && {
            maxHeight: MAX_HEIGHT,
            opacity: 1,
            overflow: "unset",
            transition: `max-height 0.6s cubic-bezier(0.4, 0.0, 0.2, 1), opacity 0.6s ease-in-out`,
        },
);

export const ChevronIcon = styled.div<{
    isExpanded?: boolean;
    currentRotation?: number;
}>(({ theme, currentRotation, isExpanded }) =>
    isExpanded
        ? {
              transform: `rotate(${currentRotation}deg)`,
              transition: "transform 0.4s ease-out",
              color: theme.colors[theme.colorMode].text_Med_Emphasis,
              height: theme.spacing.large,
          }
        : {
              transform: `rotate(${currentRotation}deg)`,
              transition: "transform 0.4s ease-in",
              color: theme.colors[theme.colorMode].text_Med_Emphasis,
              height: theme.spacing.large,
          },
);

export const ChevronRight = styled(Svg12)(({ theme }) => ({
    fill: "unset",
    marginTop: theme.spacing.xxSmall,
}));

export const IconAndTitleWrapper = styled.div`
    display: flex;
    align-items: center;
`;
export const Icon = styled(Image)(({ theme }) => ({
    marginRight: theme.spacing.small,
}));
